import { ContentsTableData } from '../../hooks'
import { Designed } from '../../types'
import { ContentsTable } from './ContentsTable'

type Props = {
  data: ContentsTableData
}

export const SidebarContentsTable = ({
  data,
  ...wrapperProps
}: Designed<Props>) => {
  if (data.headings === undefined || data.headings.length === 0) return <></>
  return (
    <div {...wrapperProps}>
      <div className="overflow-auto">
        <ContentsTable data={data} />
      </div>
    </div>
  )
}
